import { Bloc } from "@kernel/frontend-react-app";
import { ToolboxState, defaultToolboxState } from "./ToolboxState";

export class ToolboxBloc extends Bloc<ToolboxState> {
  private constructor() {
    super(defaultToolboxState);
  }

  public show() {
    if (this.state.timeoutId) {
      clearTimeout(this.state.timeoutId);
    }
    const timeoutId = setTimeout(() => {
      this.changeState({
        ...this.state,
        visible: false,
        timeoutId: null
      });
    }, 3000);

    this.changeState({
      ...this.state,
      visible: true,
      timeoutId
    });
  }

  public hide() {
    this.changeState({
      ...this.state,
      visible: false
    });
  }

  public static create() {
    return new ToolboxBloc();
  }
}
